import { ModuleFE_Variable } from '@app/hcs-frontend';
export const filterMultiVarsByABC = (mv) => ModuleFE_Variable.cache.unique(mv.variables[0].variableId).name;
export const filterMultiVarsByCreated = (mv) => mv.__created;
//# sourceMappingURL=consts.js.map